import React from 'react';
import { FiPlus, FiInbox } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const canAdd = (pagina) => pagina !== '/semButton';

export default function NenhumRegistro({ nome, pagina }) {
  const navigate = useNavigate();

  return (
    <div style={{
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      minHeight: '60vh', gap: 16, padding: 32, textAlign: 'center',
    }}>
      <div style={{
        width: 80, height: 80, borderRadius: '50%',
        background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8,
      }}>
        <FiInbox size={36} color="#94a3b8" />
      </div>

      <h6 style={{ margin: 0, fontWeight: 700, color: '#475569', fontSize: 16 }}>
        Nenhum registro encontrado
      </h6>
      <p style={{ margin: 0, color: '#94a3b8', maxWidth: 340, fontSize: 13.5 }}>
        Não há {nome} cadastrado{nome?.endsWith('a') ? 'a' : 'o'} ainda, ou você não tem permissão para visualizar.
      </p>

      {canAdd(pagina) && (
        <button
          onClick={() => navigate(pagina)}
          style={{
            marginTop: 8, height: 42, padding: '0 24px', borderRadius: 8,
            border: 'none', cursor: 'pointer', fontFamily: 'inherit',
            background: 'linear-gradient(135deg, #3d7a9c, #1e3a4c)',
            color: '#fff', fontSize: 14, fontWeight: 600,
            display: 'flex', alignItems: 'center', gap: 8,
            boxShadow: '0 4px 14px rgba(82,148,181,0.32)',
            transition: 'opacity 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.opacity = '0.9'}
          onMouseLeave={e => e.currentTarget.style.opacity = '1'}
        >
          <FiPlus size={16} />
          Adicionar {nome}
        </button>
      )}
    </div>
  );
}
